import { RemoteLastRegistrationApp } from 'data/usecases/dashboard';
import { ListLastRegistrationApp } from 'domain/usecases/dashboard';
import { makeApiUrlLastRegistrationApp } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeListLastRegistration = (): ListLastRegistrationApp =>
  new RemoteLastRegistrationApp(
    makeApiUrlLastRegistrationApp(),
    makeAxiosHttpClient(),
  );
